var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blueprint-wrapper',[_c('blueprint-header',{staticClass:"pos-relative"},[_c('app-header',{attrs:{"header-options":_vm.headerOptions}})],1),_c('blueprint-content',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('blueprint-footer',[_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }